/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chats_Move_Chat_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to move chat. Please try again." |
*
* @param {Chats_Move_Chat_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chats_move_chat_error = /** @type {((inputs?: Chats_Move_Chat_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chats_Move_Chat_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Verschieben des Chats. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to move chat. Please try again.")
});